/**
 * Antisaccade — types runtime.
 */
export const SIDES = ['left', 'right'];
export function oppositeSide(s) {
    return s === 'left' ? 'right' : 'left';
}
//# sourceMappingURL=types.js.map